export function ClientReleaseSelect({ value, options, disabled, onChange }: {
  value: string; options: string[]; disabled: boolean; onChange: (value: string) => void;
}) {
  return <label className="release-key-field"><span>客户端版本 · 已自动读取最新</span>
    <select aria-label="客户端版本" value={value} disabled={disabled} onChange={event => onChange(event.target.value)}>
      {options.map((key, index) => <option key={key} value={key}>{key}{index === 0 ? '（最新）' : ''}</option>)}
    </select>
  </label>;
}

export function ConfigIssues({ issues, serverIssue }: { issues: string[]; serverIssue: string }) {
  if (!issues.length && !serverIssue) return null;
  return <section className="config-action-issues" role="alert" aria-label="保存前需要处理的问题">
    <strong>{serverIssue ? '保存失败' : `有 ${issues.length} 项需要修正，暂时无法保存或发布`}</strong>
    {serverIssue && <p>{serverIssue}</p>}
    {issues.length > 0 && <ul>{issues.map(issue => <li key={issue}>{issue}</li>)}</ul>}
  </section>;
}
